/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import React from 'react';
import { Button, H3 } from '@blueprintjs/core';
import { Form } from "./uploadForm/UploadForm";

interface Props extends React.ComponentProps<'div'> { }
export const DataImport: React.FC<Props> = (props) => {
	const goBack = () => {
		window.history.back();
	}

	return (
		<div css={wrapperStyle} {...props}>
			<div css={headerStyle}>
				<H3>Upload Data</H3>
				<Button
					children={'Cancel'}
					onClick={goBack}
				// minimal
				/>
			</div>
			<Form />
		</div>
	);
}

const headerStyle = css`
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 1.5rem;
`

const wrapperStyle = css`
    height: 100vh; // NO!
    display: flex;
    flex-flow: column; 
    overflow: hidden; 
`;
